import { render, staticRenderFns } from "./RequestFile.vue?vue&type=template&id=2cee2d38&scoped=true&"
import script from "./RequestFile.vue?vue&type=script&lang=js&"
export * from "./RequestFile.vue?vue&type=script&lang=js&"
import style0 from "@/css/styleModules.css?vue&type=style&index=0&id=2cee2d38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee2d38",
  null
  
)

export default component.exports